module.exports = __webpack_public_path__ + "img/pro_ten_4.46e2b776.jpg";